// extracted by mini-css-extract-plugin
export var menuIcon = "_uf-0";
export var menuIconInline = "_uf-1";